import { safeParseResponse } from '../../utils';
import authorizedFetch from '../api-authorization/AuthorizedFetch';

const getContentFromCode = async function(code) {
  try {
    const response = await authorizedFetch(`api/quick-codes/${code}`);
    console.log(response);
    const { content } = await safeParseResponse(response);

    return content;
  } catch {
    return null;
  }
}

export default getContentFromCode;